import { createContext, useContext } from 'react';
import { IAmrSearchOptionsContext } from '@vivli/features/search/infrastructure/interface';

export const AmrSearchOptionsContext = createContext<IAmrSearchOptionsContext>(null);

export const useAmrSearchOptionsContext = () => useContext(AmrSearchOptionsContext);
